import { Observable } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ProjectService } from '@mitsubishi/project/data-access';
import { ButtonComponent, SectionTitleComponent, SelectModule } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-share-organization-dialog',
  imports: [
    CommonModule,
    ApmTranslatePipe,
    ButtonComponent,
    SelectModule,
    FormsModule,
    
    SectionTitleComponent,
  ],
  templateUrl: './share-organization-dialog.component.html',
  styleUrl: './share-organization-dialog.component.scss',
})
export class ShareOrganizationDialogComponent {
  organizations$: Observable<{ id: number; name: string; currencyId: number }[]> =
    this.projectService.getSharableOrganization();
  selectedOrganization: { id: number; name: string; currencyId: number } | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ShareOrganizationDialogComponent>,
    private projectService: ProjectService
  ) {}

  closeDialog(organization?: { id: number; name: string } | null) {
    this.dialogRef.close(organization);
  }
}
